import { CustomerType, Interest, IUser } from 'src/types/graphql'
import { RedirectUrls } from 'src/types/types'

const HOST_CUSTOMER_TYPES: ReadonlySet<CustomerType> = new Set([
  CustomerType.HostIndividual,
  CustomerType.HostCorporate,
  CustomerType.HostBroker
])

type UserRoleFields = Pick<IUser, 'interest' | 'customerType'>

/**
 * Default post-login destination for a given user.
 *
 * Rule: customerType wins when set (it's the more authoritative classification —
 * driven by actual deal activity). When absent, fall back to declared `interest`.
 * Anyone whose signals don't classify them as a host lands on the rent dashboard.
 * The /dashboard role landing and the public account menus (useAccountNav) use
 * this only as the tiebreak behind dashboardContext's "hosts something".
 */
export function getDefaultDashboard(
  user: UserRoleFields | null | undefined
): RedirectUrls.Dashboard | RedirectUrls.DashboardRent {
  if (user?.customerType && HOST_CUSTOMER_TYPES.has(user.customerType)) {
    return RedirectUrls.Dashboard
  }
  if (user?.customerType) {
    return RedirectUrls.DashboardRent
  }
  return user?.interest === Interest.Host
    ? RedirectUrls.Dashboard
    : RedirectUrls.DashboardRent
}
